import React from 'react';

function Shimmer({ className = '' }) {
  return <span className={`vd-ml-shimmer ${className}`.trim()} aria-hidden="true" />;
}

export function PortfolioTableSkeleton({ rows = 3 }) {
  return (
    <tbody className="vd-ml-portfolios-skeleton" aria-hidden="true">
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={index} className="vd-ml-portfolio-skeleton-row">
          <td className="vd-ml-portfolios-name-col">
            <span className="vd-ml-portfolio-skeleton-name">
              <Shimmer className="vd-ml-shimmer-logo" />
              <Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--name" />
            </span>
          </td>
          <td className="vd-ml-portfolios-gain-col"><Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--stat" /></td>
          <td className="vd-ml-portfolios-profit-col"><Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--stat" /></td>
          <td className="vd-ml-portfolios-change-col"><Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--stat" /></td>
          <td className="vd-ml-portfolios-chart-cell">
            <Shimmer className="vd-ml-shimmer-sparkline" />
          </td>
        </tr>
      ))}
    </tbody>
  );
}

export function EquityDonutSkeleton() {
  return (
    <div className="vd-ml-donut-skeleton" role="status" aria-label="Loading equity breakdown">
      <div className="vd-ml-donut-skeleton-ring-wrap">
        <div className="vd-ml-donut-skeleton-ring" />
        <div className="vd-ml-donut-skeleton-center">
          <Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--donut-total" />
          <Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--donut-sub" />
        </div>
      </div>
      <ul className="vd-ml-donut-skeleton-legend">
        <li><Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--legend" /></li>
        <li><Shimmer className="vd-ml-shimmer-line vd-ml-shimmer-line--legend" /></li>
      </ul>
    </div>
  );
}
